import { ref, reactive, computed, onUnmounted } from 'vue';
import { useVueI18n } from '@/hooks';
import useNewSms from '@/hooks/use-new-sms';

export default () => {
  const { t } = useVueI18n();
  const { isNewSms } = useNewSms();
  const columns = computed(() => [
    {
      dataIndex: 'business',
      title: t('aws.business'),
      fixed: 'left',
      width: 250,
    },
    {
      dataIndex: 'orderStatus',
      title: t('aws.orderStatus'),
      width: 200,
    },
    {
      dataIndex: 'notificationStatus',
      title: t('aws.aswStatus'),
      width: 240,
    },
    {
      dataIndex: 'orderInfo',
      title: t('aws.orderInfo'),
      align: 'right',
      width: 200,
    },
    {
      dataIndex: 'expireTime',
      title: t('aws.expireTime'),
      align: 'left',
    },
    {
      dataIndex: 'createTime',
      title: t('aws.createTime'),
      align: 'left',
    },
    {
      dataIndex: 'operate',
      fixed: 'right',
      width: 160,
      title: t('aws.operate'),
    },
  ]);
  const businessList = computed(() => {
    return [
      { label: t('aws.allBusiness'), value: '' },
      { label: 'AppPush', value: 'AppPush' },
      { label: 'WebPush', value: 'WebPush' },
      { label: 'WhatsApp', value: 'WhatsApp' },
      { label: 'SMS', value: isNewSms.value ? 'NEWSMS' : 'SMS' },
      { label: 'Email', value: 'Email' },
      { label: 'OTP', value: 'OTP' },
      { label: 'NEWSMS', value: 'NEWSMS' },
    ];
  });
  const orderStatusList = computed(() => {
    return [
      { label: t('aws.order.status'), value: '' },
      { label: t('aws.pending'), value: 'pending' },
      { label: t('aws.unbind'), value: 'unbind' },
      { label: t('aws.bound'), value: 'bound' },
      { label: t('aws.cancelled'), value: 'cancelled' },
    ];
  });

  return {
    columns,
    businessList,
    orderStatusList,
  };
};
